if (!customElements.get('newsletter-form')) {
  customElements.define(
    'newsletter-form',
    class NewsletterForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this.isKlaviyoForm) {
          this.form?.addEventListener('submit', this.onSubmit.bind(this))
        }
      }

      disconnectedCallback() {
        if (this.isKlaviyoForm) {
          this.form?.removeEventListener('submit', this.onSubmit.bind(this))
        }
      }

      async onSubmit(event) {
        event.preventDefault()
        this.querySelectorAll('.field')
          .forEach(element => element.classList.remove('field--has-errors'))
        this.form?.classList.remove('success')

        const email = this.emailField?.value || ''
        if (!email || !this.isValidEmail(email)) {
          this.emailField?.closest('.field')?.classList.add('field--has-errors')
          return false
        }

        const options = {
          method: 'POST',
          headers: {
            revision: '2024-05-15',
            'Content-Type': 'application/json',
          },
          body: `{
            "data": {
              "type": "subscription",
              "attributes": {
                "custom_source": "Homepage footer signup form",
                "profile": {
                  "data": {
                    "type": "profile",
                    "attributes": {
                      "email": "${email}"
                    }
                  }
                }
              },
              "relationships": {
                "list": {
                  "data": {
                    "type": "list",
                    "id": "${this.klaviyoListID}"
                  }
                }
              }
            }
          }`
        };
        const subscriptionResponse = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${this.klaviyoCompanyID}`,
          options,
        );

        this.emailField.value = ''
        this.form?.classList.add('success')
      }

      isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      }

      get klaviyoCompanyID() {
        return this.getAttribute('data-company-id')
      }

      get klaviyoListID() {
        return this.getAttribute('data-list-id')
      }

      get emailField() {
        return this.querySelector('[name="contact[email]"]')
      }

      get isKlaviyoForm() {
        return this.getAttribute('data-type') == 'klaviyo'
      }

      get form() {
        return this.querySelector('form')
      }
    }
  );
}
